import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["priceFrame", "childFields", "childOption"]

    connect() {
        // Initialize based on the currently selected child radio
        const input = this.currentChildInput()
        if (input) {
            this.applySelection(input.value, input.dataset)
        } else {
            // No selection yet: keep fields hidden
            this.toggleChildFields(false)
        }
    }

    // When a child radio is selected
    onChildSelect(event) {
        const input = event?.target || this.currentChildInput()
        if (!input) return
        this.applySelection(input.value, input.dataset)
    }

    applySelection(value, dataset) {
        if (!this.hasChildFieldsTarget) return
        const isAnother = value === ""
        if (isAnother) {
            this.clearNewChildFields()
            this.toggleParentRemarks(false)
        } else {
            this.prefillExistingChildFields(dataset)
            this.toggleParentRemarks(dataset)
        }
        this.toggleChildFields(true)
    }

    toggleChildFields(show) {
        if (!this.hasChildFieldsTarget) return
        this.childFieldsTarget.classList.toggle("d-none", !show)
    }

    currentChildInput() {
        // Find the checked radio for child_id within this controller element
        return this.element.querySelector("input[type='radio'][name$='[child_id]']:checked")
    }

    prefillExistingChildFields(ds) {
        const form = 'subscriptions_existing_parent_form'
        const byId = (suffix) => document.getElementById(`${form}_${suffix}`)

        // Text inputs
        const first = byId('child_first_name')
        const last = byId('child_last_name')
        const birth = byId('child_birthdate')
        const email = byId('child_email')
        const registrationNumber = byId('child_registration_number')
        const schoolName = byId('school_name')
        const schoolCity = byId('school_city')

        if (first) {
            first.value = ds.firstName || ''
            first.readOnly = !!ds.firstName
        }
        if (last) {
            last.value = ds.lastName || ''
            last.readOnly = !!ds.lastName
        }
        if (birth) {
            birth.value = ds.birthdate || ''
        }
        if (email) {
            email.value = ds.email || ''
        }
        if (registrationNumber) {
            registrationNumber.value = ds.registrationNumber || ''
        }
        if (schoolName) {
            schoolName.value = ds.schoolName || ''
        }
        if (schoolCity) {
            schoolCity.value = ds.schoolCity || ''
        }

        // Gender radio group
        const gender = ds.gender
        const genderName = `${form}[child_gender]`
        const genderInputs = document.querySelectorAll(`input[name='${genderName}']`)
        if (genderInputs.length) {
            if (gender) {
                genderInputs.forEach((el) => {
                    el.disabled = true
                    if (el.id === `${form}_child_gender_${gender}`) {
                        el.disabled = false
                        el.checked = true
                    }
                })
            } else {
                genderInputs.forEach((el) => {
                    el.disabled = false
                    el.checked = false
                })
            }
        }
    }

    clearNewChildFields() {
        const form = 'subscriptions_existing_parent_form'
        const byId = (suffix) => document.getElementById(`${form}_${suffix}`)
        const first = byId('child_first_name')
        const last = byId('child_last_name')
        const birth = byId('child_birthdate')
        const email = byId('child_email')
        const registrationNumber = byId('child_registration_number')
        const schoolName = byId('school_name')
        const schoolCity = byId('school_city')

        if (first) {
            first.value = '';
            first.readOnly = false
        }
        if (last) {
            last.value = '';
            last.readOnly = false
        }
        if (birth) {
            birth.value = ''
        }
        if (email) {
            email.value = ''
        }
        if (registrationNumber) {
            registrationNumber.value = ''
        }
        if (schoolName) {
            schoolName.value = ''
        }
        if (schoolCity) {
            schoolCity.value = ''
        }

        const genderName = `${form}[child_gender]`
        const genderInputs = document.querySelectorAll(`input[name='${genderName}']`)
        genderInputs.forEach((el) => {
            el.disabled = false;
            el.checked = false
        })
    }

    toggleParentRemarks(dsOrBool) {
        const container = document.getElementById('parent_remarks')
        if (!container) return

        // Determine visibility
        let show = false
        let childId = null
        if (typeof dsOrBool === 'boolean') {
            show = dsOrBool
        } else if (dsOrBool) {
            // dataset boolean comes as string "true"/"false"
            show = String(dsOrBool.parentRemarksAny) === 'true'
            childId = dsOrBool.id
        }

        container.classList.toggle('d-none', !show)

        // Filter remarks per child
        if (childId) {
            const items = container.querySelectorAll('.parent_remark')
            items.forEach((el) => {
                const elChildId = String(el.dataset.childId)
                el.classList.toggle('d-none', elChildId !== String(childId))
            })
        }
    }
}
